/** The different endpoint actions available for the Member route. */
export enum MemberActions {
  Sponsored = 'sponsored-legislation',
  Cosponsored = 'cosponsored-legislation'
}
